import * as React from "react"
import { Product } from "../../interfaces/SaleorTypes"
import AccessoriesCard from "../../organisms/store/AccessoriesCard"
import { Row } from "react-grid-system"
import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"

interface Props {
  accessory: Product
  onClickAddItem: (item: Product, number: number) => void
}

const ContentContainer = styled.div`
  width: 80vw;
  max-width: 1200px;
  padding: 1rem;

  ${MediaQuery.XS} {
    width: 90vw;
    padding: 0.5rem;
  }

  ${MediaQuery.SM} {
    width: 90vw;
    max-width: 1500px;
  }
`

const AccessoryModalContent: React.FC<Props> = ({ accessory, onClickAddItem }) => {
  const EmptyFunction = () => {}

  return (
    <ContentContainer>
      <Row justify="center">
        <AccessoriesCard
          product={accessory}
          addToCart={EmptyFunction}
          hideAddToCart={false}
          onClickAddItem={onClickAddItem}
        />
      </Row>
    </ContentContainer>
  )
}

export default AccessoryModalContent
